import './style.scss';

import { useTranslation } from 'react-i18next';

// import { useQuery } from 'react-query';
// import { useMemo } from 'react';

import PropTypes from 'prop-types';
// import { mapError } from 'utils/func';
import { useQuery } from 'react-query';
import { Button } from 'primereact/button';
import { toast } from 'layout';
import { downloadDocxFile, downloadPdfFile } from 'apis/projects.api';
import { TIMEZONE_VN } from 'constant';

function DetailContractInfo({ data, dataContract }) {
  // region data
  const { t } = useTranslation();

  const currencyOptions = {
    style: 'currency',
    currency: 'VND',
  };

  const projectProposalOrganizations = data?.projectProposalOrganizations[0];
  const projectProposalContacts = data?.projectProposalContacts[0];
  const effectiveDate = new Date(dataContract?.effectiveDate).toLocaleDateString('en-GB', {
    timeZone: TIMEZONE_VN,
  });
  const totalMonths = Number(dataContract?.startMonth) + Number(dataContract?.implementationMonths);
  const monthTo = totalMonths % 12 === 0 ? 12 : totalMonths % 12;
  const yearTo =
    totalMonths % 12 === 0
      ? Number(dataContract?.startYear) + Math.floor((totalMonths - 1) / 12)
      : Number(dataContract?.startYear) + Math.floor(totalMonths / 12);

  const {
    refetch: handleDownloadDocxFile,
    isLoading: isDownloadDocxFileLoading,
    isFetching: isDownloadDocxFileFetching,
  } = useQuery(['downloadProjectProposalDocxFile'], () => downloadDocxFile(dataContract?.id), {
    enabled: false,
    onSuccess: (res) => {
      if (res?.data) {
        const file = new Blob([res.data]);
        const filename = 'Hop dong.docx';
        const link = document.createElement('a');
        link.href = URL.createObjectURL(file);
        link.download = filename;

        link.click();
      }
    },
    onError: () => {
      toast('error', t('projectProposal.review.exportDocxErrorTitle'));
    },
  });

  const {
    refetch: handleDownloadPdfFile,
    isLoading: isDownloadPdfFileLoading,
    isFetching: isDownloadPdfFileFetching,
  } = useQuery(['downloadProjectProposalPdfFile'], () => downloadPdfFile(dataContract?.id), {
    enabled: false,
    onSuccess: (res) => {
      if (res?.data) {
        const file = new Blob([res.data]);
        const filename = 'Hop dong.pdf';
        const link = document.createElement('a');
        link.href = URL.createObjectURL(file);
        link.download = filename;

        link.click();
      }
    },
    onError: () => {
      toast('error', t('projectProposal.review.exportPdfErrorTitle'));
    },
  });

  const formatExpenditure = (expenditure) =>
    expenditure?.toLocaleString('vi', currencyOptions) ?? 0;

  // #endregion
  return (
    <div className="m-0 bg-white p-5 p-fluid">
      {dataContract?.effectiveDate && (
        <div className="mb-5 flex justify-content-end gap-2">
          <Button
            type="button"
            label={t('council.review.exportDocx')}
            icon={`pi ${
              isDownloadDocxFileLoading || isDownloadDocxFileFetching
                ? 'pi-spin pi-spinner'
                : 'pi-file-word'
            }`}
            className="block w-auto h-3rem"
            severity="info"
            onClick={handleDownloadDocxFile}
            disabled={isDownloadDocxFileLoading || isDownloadDocxFileFetching}
          />
          <Button
            type="button"
            label={t('council.review.exportPdf')}
            icon={`pi ${
              isDownloadPdfFileLoading || isDownloadPdfFileFetching
                ? 'pi-spin pi-spinner'
                : 'pi-file-pdf'
            }`}
            className="block w-auto h-3rem border-none"
            // severity="info"
            style={{ backgroundColor: 'var(--red-400)' }}
            onClick={handleDownloadPdfFile}
            disabled={isDownloadPdfFileLoading || isDownloadPdfFileFetching}
          />
        </div>
      )}

      <div className="mb-5 flex justify-content-between align-items-center">
        <img
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="VNU-HCM logo"
          height="75px"
          className="ml-3"
        />
        <div>
          <span>{t('contract.m04.sample')}</span>
          <br />
          <span>
            {t('contract.m04.typeOfProject')} {data?.projectType === 'C' ? 'C' : 'A, B'}
          </span>
        </div>
      </div>
      <div className="flex justify-content-center align-items-center">
        <h4>{t('contract.m04.nationalName')}</h4>
      </div>
      <div className="flex justify-content-center align-items-center">
        <h4>{t('contract.m04.motto')}</h4>
      </div>
      <hr />
      <div className="flex justify-content-end p-2">
        <p>
          ..................., {t('contract.m04.day')} ...., {t('contract.m04.month')} ...,{' '}
          {t('contract.m04.year')} ....
        </p>
      </div>
      <div className="flex justify-content-center align-items-center mb-0">
        <h4>{t('contract.m04.contractPerformance')}</h4>
      </div>
      <div className="flex justify-content-center align-items-center mt-0">
        <h4>{t('contract.m04.topic')}</h4>
      </div>
      <div className="flex justify-content-center align-items-center mt-0">
        <p>{t('contract.m04.number')}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/HĐ-KHCN</p>
      </div>
      {/* section intro */}
      <section className="first-line-indent">
        <p>&ndash; {t('contract.m04.intro.no1')}</p>
        <p>&ndash; {t('contract.m04.intro.no2')}</p>
        <p>&ndash; {t('contract.m04.intro.no3')}</p>
        <p>&ndash; {t('contract.m04.intro.no4')}</p>
        <p>
          &ndash; {t('contract.m04.intro.no5')}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {t('contract.m04.intro.no6')} ..... {t('contract.m04.month')} .....&nbsp;
          {t('contract.m04.year')} 20... &nbsp;
          {t('contract.m04.intro.no7')}...........;
        </p>
        <br />
        <p>
          <b>{t('contract.m04.include')}</b>
        </p>
      </section>
      {/* Section Ben A - Contract A-B */}
      {(data?.projectType === 'A' || data?.projectType === 'B') && (
        <section className="first-line-indent">
          <p>
            <b>
              {t('contract.m04.sender')} {t('contract.m04.A.agency')}
            </b>
          </p>
          <p>
            &ndash; {t('contract.m04.represent')} {t('contract.m04.A.represent')}
          </p>
          <p className="red-text-color">
            {' '}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {t('contract.m04.A.note')}
          </p>
          <p>
            &ndash; {t('contract.m04.position')} {t('contract.m04.A.position')}
          </p>
          <p>
            &ndash; {t('contract.m04.address')} {t('contract.m04.A.address')}
          </p>
          <p>
            &ndash; {t('contract.m04.phoneNumber')} {t('contract.m04.A.phone')}
          </p>
          <p>
            &ndash; {t('contract.m04.fax')} {t('contract.m04.A.fax')}
          </p>
          <br />
        </section>
      )}

      {/* Section Ben A - contract C */}
      <section className="first-line-indent">
        {data?.projectType === 'C' ? (
          <>
            <p>
              <b>{t('contract.m04.sender')}</b>
            </p>
            <p>
              <b>{t('contract.m04.leadAgency')}</b>
            </p>
          </>
        ) : (
          <>
            <p>
              <b>{t('contract.m04.recipient')}</b>
            </p>
            <p>
              <b>1. {t('contract.m04.leadAgency')}</b>
            </p>
          </>
        )}
        <p>
          &ndash; {t('contract.m04.represent')} {projectProposalOrganizations.chief}
        </p>
        <p>
          &ndash; {t('contract.m04.position')} {projectProposalOrganizations.type}
        </p>
        <p>
          &ndash; {t('contract.m04.address')} {projectProposalOrganizations.address}
        </p>
        <p>
          &ndash; {t('contract.m04.phoneNumber')} {projectProposalOrganizations.phone}
        </p>
        <p>
          &ndash; {t('contract.m04.fax')} {projectProposalOrganizations.fax}
        </p>
        <p>
          &ndash; {t('contract.m04.accountNumber')} {projectProposalOrganizations.bankAccount}
        </p>
        <p>
          &ndash; {t('contract.m04.treasuryOpen')} {projectProposalOrganizations.bank}
        </p>
        <br />
      </section>
      <section className="first-line-indent">
        <p>
          <b>2. {t('contract.m04.leader')} </b>
        </p>
        <p>
          &ndash; {t('contract.m04.fullName')} {projectProposalContacts.fullname}
        </p>
        <p>
          &ndash; {t('contract.m04.address')} {projectProposalContacts.organization.name}
        </p>
        <p>
          &ndash; {t('contract.m04.mobileNumber')} {projectProposalContacts.mobile}
        </p>
        <p>
          &ndash; {t('contract.m04.email')} {projectProposalContacts.email}
        </p>
        <p>
          &ndash; {t('contract.m04.accountNumber')} {projectProposalContacts.bankAccount}
        </p>
        <p>
          &ndash; {t('contract.m04.bankOpen')} {projectProposalContacts.bank}
        </p>
      </section>
      {/* Section terms */}
      <section className="first-line-indent terms">
        <p>{t('contract.m04.terms.intro')}</p>
        {/* term 1 */}
        <p>
          <b>{t('contract.m04.terms.no1.name')}</b>
        </p>
        <p>
          {t('contract.m04.terms.no1.1')}&nbsp;
          <span className="font-bold"> &quot;{data?.vietnameseName || ' ... '}&quot;</span>{' '}
          {t('contract.m04.terms.no1.2')}
        </p>
        <p>{t('contract.m04.terms.no1.3')}</p>
        {/* term 2 */}
        <p>
          <b>{t('contract.m04.terms.no2.name')}</b>
        </p>
        <p>
          {t('contract.m04.terms.no2.1')}&nbsp;
          {dataContract?.implementationMonths || ' ..... '} {t('contract.m04.month')},&nbsp;
          {t('contract.m04.from')} {t('contract.m04.month')}{' '}
          {dataContract?.startMonth || ' ...... '}&nbsp;
          {t('contract.m04.year')} {dataContract?.startYear || ' ...... '}&nbsp;
          {t('contract.m04.to')} {t('contract.m04.month')} {monthTo || ' ...... '}&nbsp;
          {t('contract.m04.year')} {yearTo || ' ...... '}.
        </p>
        {/* term 3 */}
        <p>
          <b>{t('contract.m04.terms.no3.name')}</b>
        </p>
        <p>
          1. {t('contract.m04.terms.no3.1.1')}{' '}
          {formatExpenditure(dataContract?.totalExpenditure) || '............'} ,&nbsp;
          {t('contract.m04.terms.no3.1.2')}
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&ndash; {t('contract.m04.terms.no3.1.3')}{' '}
          {formatExpenditure(dataContract?.expenditureFromVNU) || '............'} .
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ {t('contract.m04.terms.no3.1.4')}{' '}
          {formatExpenditure(dataContract?.fixedExpenditure) || '............'} .
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ {t('contract.m04.terms.no3.1.5')}{' '}
          {formatExpenditure(dataContract?.flexibleExpenditure) || '............'} .
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&ndash; {t('contract.m04.terms.no3.1.6')}{' '}
          {formatExpenditure(dataContract?.expenditureFromFunding) || '............'} .
        </p>
        <p>2. {t('contract.m04.terms.no3.2.name')}</p>
        <p className="red-text-color">{t('contract.m04.terms.no3.2.1')}</p>
        <p className="red-text-color">{t('contract.m04.terms.no3.2.2')}</p>
        <p className="red-text-color">{t('contract.m04.terms.no3.2.3')}</p>
        <p className="red-text-color">{t('contract.m04.terms.no3.2.4')}</p>
        <p className="red-text-color">{t('contract.m04.terms.no3.2.5')}</p>
        {/* term 4 */}
        <p>
          <b>{t('contract.m04.terms.no4.name')}</b>
        </p>
        <p>
          <b>1. {t('contract.m04.terms.no4.1.name')}</b>
        </p>
        <ol type="a">
          <li>{t('contract.m04.terms.no4.1.1')}</li>
          <li>{t('contract.m04.terms.no4.1.2')}</li>
          <li>{t('contract.m04.terms.no4.1.3')}</li>
          <li>{t('contract.m04.terms.no4.1.4')}</li>
          <li>{t('contract.m04.terms.no4.1.5')}</li>
          <li>{t('contract.m04.terms.no4.1.6')}</li>
          <li>{t('contract.m04.terms.no4.1.7')}</li>
          <li>{t('contract.m04.terms.no4.1.8')}</li>
          <li>{t('contract.m04.terms.no4.1.9')}</li>
          <li>{t('contract.m04.terms.no4.1.10')}</li>
          <li>{t('contract.m04.terms.no4.1.11')}</li>
          <li>{t('contract.m04.terms.no4.1.12')}</li>
        </ol>
        <p>
          <b>2. {t('contract.m04.terms.no4.2.name')}</b>
        </p>
        <ol type="a">
          <li>{t('contract.m04.terms.no4.2.1')}</li>
          <li>{t('contract.m04.terms.no4.2.2')}</li>
          <li>{t('contract.m04.terms.no4.2.3')}</li>
          <li>{t('contract.m04.terms.no4.2.4')}</li>
          <li>{t('contract.m04.terms.no4.2.5')}</li>
          <li>{t('contract.m04.terms.no4.2.6')}</li>
          <li>{t('contract.m04.terms.no4.2.7')}</li>
          <li>{t('contract.m04.terms.no4.2.8')}</li>
          <li>{t('contract.m04.terms.no4.2.9')}</li>
          <li>{t('contract.m04.terms.no4.2.10')}</li>
          <li>{t('contract.m04.terms.no4.2.11')}</li>
          <li>{t('contract.m04.terms.no4.2.12')}</li>
          <li>{t('contract.m04.terms.no4.2.13')}</li>
          <li>
            {t('contract.m04.terms.no4.2.14.1')}
            <p>{t('contract.m04.terms.no4.2.14.2')}</p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ {t('contract.m04.terms.no4.2.14.3')}
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ {t('contract.m04.terms.no4.2.14.4')}
            </p>
            <p>{t('contract.m04.terms.no4.2.14.5')}</p>
            <p>{t('contract.m04.terms.no4.2.14.6')}</p>
            <p>{t('contract.m04.terms.no4.2.14.7')}</p>
            <p>{t('contract.m04.terms.no4.2.14.8')}</p>
          </li>
          <li>{t('contract.m04.terms.no4.2.15')}</li>
          <li>{t('contract.m04.terms.no4.2.16')}</li>
          <li>{t('contract.m04.terms.no4.2.17')}</li>
          <li>{t('contract.m04.terms.no4.2.18')}</li>
        </ol>
        {/* term 5 */}
        <p>
          <b>{t('contract.m04.terms.no5.name')}</b>
        </p>
        <p>{t('contract.m04.terms.no5.1.name')}</p>
        <ol type="1">
          <li>{t('contract.m04.terms.no5.1.1')}</li>
          <li>{t('contract.m04.terms.no5.1.2')}</li>
          <li>{t('contract.m04.terms.no5.1.3')}</li>
          <li>{t('contract.m04.terms.no5.1.4')}</li>
          <li>
            {t('contract.m04.terms.no5.1.5.name')}
            <p>a) {t('contract.m04.terms.no5.1.5.1')}</p>
            <p>b) {t('contract.m04.terms.no5.1.5.2')}</p>
          </li>
        </ol>
        {/* term 6 */}
        <p>
          <b>{t('contract.m04.terms.no6.name')}</b>
        </p>
        <ol type="1">
          <li>
            {t('contract.m04.terms.no6.1.name')}
            <p>a) {t('contract.m04.terms.no6.1.1')}</p>
            <p>b) {t('contract.m04.terms.no6.1.2')}</p>
          </li>
          <li>
            {t('contract.m04.terms.no6.2.name')}
            <p>a) {t('contract.m04.terms.no6.2.1')}</p>
            <p>b) {t('contract.m04.terms.no6.2.2')}</p>
          </li>
          <li>{t('contract.m04.terms.no6.3')}</li>
          <li>{t('contract.m04.terms.no6.4')}</li>
          <li>{t('contract.m04.terms.no6.5')}</li>
        </ol>
        {/* term 7 */}
        <p>
          <b>{t('contract.m04.terms.no7.name')}</b>
        </p>
        <p>1. {t('contract.m04.terms.no7.1')}</p>
        <p>2. {t('contract.m04.terms.no7.2')}</p>
        {/* term 8 */}
        <p>
          <b>{t('contract.m04.terms.no8.name')}</b>
        </p>
        <p>1. {t('contract.m04.terms.no8.1')}</p>
        <p>2. {t('contract.m04.terms.no8.2')}</p>
        <p>3. {t('contract.m04.terms.no8.3')}</p>
        <p>4. {t('contract.m04.terms.no8.4')}</p>
        {/* term 9 */}
        <p>
          <b>{t('contract.m04.terms.no9.name')}</b>
        </p>
        <p>
          {t('contract.m04.terms.no9.1')}
          <span className="font-semibold">
            {effectiveDate !== 'Invalid Date' ? effectiveDate : ' .... '}
          </span>
          . {t('contract.m04.terms.no9.2')}
        </p>
      </section>
      {/* section signatures */}
      <section>
        <div className="grid mt-5">
          <div className="col-6 text-center">
            <h5>{t('contract.m04.senderUpper')}</h5>
            {data?.projectType === 'C' ? (
              <h5 className="uppercase">{t('contract.m04.leadAgency')}</h5>
            ) : (
              <h5 className="uppercase">{t('contract.m04.managementAgency')}</h5>
            )}
          </div>
          <div className="col-6 text-center">
            <h5>{t('contract.m04.recipientUpper')}</h5>
            {data?.projectType === 'C' ? (
              <h5 className="uppercase">{t('contract.m04.leader')}</h5>
            ) : (
              <>
                <h5 className="uppercase">{t('contract.m04.leadAgency')}</h5>
                <br />
                <br />
                <br />
                <br />
                <br />
                <h5>{t('contract.m04.leader')}</h5>
                <p>{t('contract.m04.signature')}</p>
              </>
            )}
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
      </section>
    </div>
  );
}

DetailContractInfo.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  dataContract: PropTypes.object.isRequired,
};

export default DetailContractInfo;
